<template>
  <div>
    <!--搜索框-->
    <div class="common-seach-wrap">
      <el-form
        size="small"
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
      >
        <el-form-item label="会员信息">
          <el-input
            v-model="searchForm.search"
            placeholder="真实姓名|身份证"
          ></el-input>
        </el-form-item>
        <el-form-item label="订单号"
          ><el-input
            size="small"
            v-model="searchForm.order_no"
            placeholder="请输入订单号"
          ></el-input
        ></el-form-item>
        <!-- <el-form-item label="支付状态">
                    <el-select size="small" v-model="searchForm.is_pay_status" placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="未支付" value="0"></el-option>
                        <el-option label="已支付" value="1"></el-option>
                        <el-option label="已逾期" value="2"></el-option>
                    </el-select>
                </el-form-item> -->
        <!-- <el-form-item label="起始时间">
                    <div class="block">
                        <span class="demonstration"></span>
                        <el-date-picker size="small" v-model="searchForm.create_time" type="daterange"
                            value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期"></el-date-picker>
                    </div>
                </el-form-item> -->
        <el-form-item
          ><el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="onSubmit"
            >查询</el-button
          ></el-form-item
        >
        <!-- <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item> -->
      </el-form>
    </div>
    <!--表格-->
    <el-table :data="tableData.data" style="width: 100%">
      <el-table-column label="ID" width="50">
        <template slot-scope="scope">
          {{ scope.row.user_id }}
        </template>
      </el-table-column>

      <el-table-column label="姓名">
        <template slot-scope="scope">
          {{ scope.row.username }}
          <!-- <div>身份证号：{{ scope.row.usernum }}</div>
                    <div>订单号：{{ scope.row.order_no }}</div> -->
        </template>
      </el-table-column>

      <el-table-column label="订单号" width="150">
        <template slot-scope="scope">
          {{ scope.row.order_no }}
        </template>
      </el-table-column>

      <!-- <el-table-column label="图片" width="60">
                <template slot-scope="scope" v-if="!scope.row.is_top_row">
                    <div style="display:flex;justify-content:center;align-items:center;">
                        <img style="width: 65px;height: 65px;" :src="scope.row.product[0].image.file_path">
                    </div>
                </template>
            </el-table-column> -->

      <el-table-column label="订单信息" width="200">
        <template slot-scope="scope">
          <div
            class="product-info"
            v-for="(item, index) in scope.row.product"
            :key="index"
          >
            <div class="info">
              <div class="name gray3 product-name">
                <span>{{ item.product_name.slice(0, 18) }}</span>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="租赁开始时间" width="150">
        <template slot-scope="scope">
          {{ scope.row.update_time | formatDate }}
        </template>
      </el-table-column>

      <el-table-column label="租期">
        <template slot-scope="scope">
          {{ scope.row.current_period }}/{{ scope.row.Total_number_of_periods }}
        </template>
      </el-table-column>

      <el-table-column label="月租金">
        <template slot-scope="scope"> ￥{{ scope.row.price }} </template>
      </el-table-column>

      <el-table-column label="已扣金额(元)" width="100">
        <template slot-scope="scope">
          {{ scope.row.is_pay_status == 1 ? "￥" + scope.row.price : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="支付状态">
        <template slot-scope="scope">
          <div v-if="scope.row.is_pay_status == '1'" style="color: #18bc9c">
            已支付
          </div>
          <div
            v-else-if="scope.row.is_pay_status == '2'"
            style="color: #18bc9c"
          >
            已逾期
          </div>
          <div
            v-else-if="scope.row.is_pay_status == '0'"
            style="color: #ff0000"
          >
            未支付
          </div>
        </template>
      </el-table-column>

      <el-table-column label="支付时间" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.paytime > 0">
            {{ scope.row.paytime | formatDate2 }}
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>

      <el-table-column label="支付方式">
        <template slot-scope="scope">
          <div
            v-if="scope.row.is_pay_status == '1'"
            style="color: cornflowerblue"
          >
            <div v-if="scope.row.transaction_id > 0 && scope.row.paytime > 0">
              支付宝扣款
            </div>
            <div
              v-else-if="scope.row.transaction_id == 0 && scope.row.paytime > 0"
            >
              蚂蚁链代扣
            </div>
            <div
              v-else-if="
                scope.row.transaction_id == 0 && scope.row.paytime == 0
              "
            >
              后台操作
            </div>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>

      <el-table-column label="本期还租时间" width="150">
        <template slot-scope="scope">
          {{ scope.row.repayment_date | formatDate2 }}
        </template>
      </el-table-column>

      <el-table-column label="审核人" width="250">
        <template slot-scope="scope">
          {{ scope.row.remarks_operation }}
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="110">
        <template slot-scope="scope">
          <el-button @click="addClick(scope.row)" type="info" size="small"
            >订单详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background:current-page="curPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, prev,sizes ,pager, next, jumper"
        :total="totalDataNumber"
      >
      </el-pagination>
    </div>
  </div>
</template>
  
<script>
import store from "@/store/";
import AuthApi from '@/api/auth.js';
import OrderApi from "@/api/order.js";
import { timeFormat } from "@/utils/timeFormat";
import Logistics from "@/components/logistics/viewLogistics.vue";
import qs from "qs";
export default {
  name: "Login",
  components: {
    Logistics,
  },
  data() {
    return {
      /*切换菜单*/
      activeName: "all",
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        search: "",
        order_no: "",
        style_id: "",
        create_time: "",
        total_price: "",
        price: "",
        is_pay_status: "",
      },
      total_amount: "",
      to_be_returned: "",
      already_repaid: "",
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    /*获取列表*/
    async getData() {
      let self = this;
      self.loading = true;
      let Params = this.searchForm;
      var resp = await store.dispatch("common/getBaseInfo");
      if (resp.role != "") {
        if (resp.role[0].role_id == 4) {
          Params.tuiguang_id = Params.tuiguang_id;
        }
      } else {
        Params.tuiguang_id = "";
      }
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      OrderApi.shortdhindex(Params, true)
        .then((res) => {
          console.log(res);
          self.totalDataNumber = res.data.list.total;
          self.tableData = res.data.list;
          return;
          //已还
          self.already_repaid = res.data.statistics.already_repaid;
          //待归还
          self.to_be_returned = res.data.statistics.to_be_returned;
          //总计
          self.total_amount = res.data.statistics.total_amount;

          self.loading = false;
        })
        .catch((error) => {});
    },
    /*刷新*/
    shuaixn() {
      this.loading = true;
      this.getData();
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    /*导出*/
    onExport: function () {
      let baseUrl = window.location.protocol + "//" + window.location.host;
      window.location.href =
        baseUrl +
        "/index.php/shop/order.operate/export?" +
        qs.stringify(this.searchForm);
    },
    /*订单详情*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      let routeData = self.$router.resolve({
        path: "/order/order/Detail",
        query: { order_id: params },
      });
      window.open(routeData.href, "_blank");
    },
  },

  filters: {
    // 过滤器
    formatDate(create_time) {
      let date = new Date((create_time + 259200) * 1000);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s; //年月日时分秒
    },
    formatDate2(create_time) {
      let date = new Date(create_time * 1000);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s; //年月日时分秒
    },
  },
};
</script>
<style lang="scss">
.el-table td,
.el-table th {
  padding: 0;
}

.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}

.pic {
  width: 50px;
  height: 50px;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>
  


// WEBPACK FOOTER //
// src/views/order/order/shortdhindex.vue